export const themes = {
  light: {
    body: {
      background: '#ffffff',
      color: '#000000'
    },
    text: {
      color: '#000000',
      fontSize: '60px'
    },
    bar: {
      color: 'gray',
    },
    home: {
      background1: '#ffffff',
      background2: '#e2e5e8',
      color: '#000000',
    }
  },
  dark: {
    body: {
      background: '#000000',
      color: '#ffffff'
    },
    text: {
      color: '#ffffff',
      fontSize: '30px'
    },
    bar: {
      color: 'lightgray',
    },
    home: {
      background1: '#000000',
      background2: '#222528',
      color: '#ffffff',
    }
  }

}